import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  accent: { bg: 'bg-accent-50 hover:bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-100 text-accent-600' },
  primary: { bg: 'bg-primary-50 hover:bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-100 text-primary-600' },
  secondary: { bg: 'bg-secondary-50 hover:bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-100 text-secondary-600' },
};

export default function HomeCategories() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            资源分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            六大核心分类，覆盖成人健康教育全领域，助你快速定位所需资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.accent;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group ${colors.bg} rounded-lg p-5 md:p-6 transition-all duration-200 cursor-pointer`}
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg ${colors.iconBg} mb-4 transition-transform group-hover:scale-110`}>
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className={`text-base md:text-lg font-semibold ${colors.text} font-heading mb-2`}>
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {cat.desc}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                  <span>{cat.websites.length} 个资源</span>
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-1"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}